// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class PharmacyBiSpecialtyPharmacy {
    static getAttributeTypeMap() {
        return PharmacyBiSpecialtyPharmacy.attributeTypeMap;
    }
}
PharmacyBiSpecialtyPharmacy.discriminator = undefined;
PharmacyBiSpecialtyPharmacy.additionalProperties = false;
PharmacyBiSpecialtyPharmacy.attributeTypeMap = [
    {
        "name": "name",
        "baseName": "name",
        "type": "string"
    },
    {
        "name": "npi",
        "baseName": "npi",
        "type": "string"
    },
    {
        "name": "preferred",
        "baseName": "preferred",
        "type": "boolean"
    },
];
//# sourceMappingURL=pharmacyBiSpecialtyPharmacy.js.map